import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {ShapeSingleDiscriminationCountModel} from '../../../../../models/questions/subModels/shapeSingleDiscriminationCount.model';
import {ImagePatternSingleFillModel} from '../../../../../models/questions/subModels/imagePatternSingleFill.model';
import {EvoListSelectorService} from '../../../../../shared/modals/evo-list-selector/evo-list-selector.service';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-image-pattern-single-fill',
  templateUrl: './evo-image-pattern-single-fill.component.html',
  styleUrls: ['./evo-image-pattern-single-fill.component.css']
})
export class EvoImagePatternSingleFillComponent implements OnInit {

  QuestionModel = QuestionModel;
  @Input() question: QuestionModel = new ImagePatternSingleFillModel();

  constructor(private selectorSv: EvoListSelectorService) { }

  ngOnInit() {
  }

  castedQuestion(): ImagePatternSingleFillModel {

    return <ImagePatternSingleFillModel>this.question;
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.castedQuestion().subCategory === Enums.QuestionSubcategories.imagePatternSingleFill) {
        return true;
      }
    }

    return false;
  }

  questionString(): string {

    let string = '';
    for (let i = 0; i < this.castedQuestion().model.numPatternValues; i++) {

      if (i === this.castedQuestion().model.missingPatternIndex) {
        string += 'Unknown, ';
      } else {
        if (this.castedQuestion().model.pattern.length !== 0) {
          const patternIndex = i % this.castedQuestion().model.pattern.length;
          string += this.castedQuestion().model.pattern[patternIndex] + ', ';
        }
      }

    }

    return string;

  }

  removePattern(index: number) {
    if (index < this.castedQuestion().model.pattern.length) {
      this.castedQuestion().model.pattern.splice(index, 1);
    }
  }

  showPatternSelector() {

    const imageList = Enums.ShapeImages.list().concat(Enums.QuestionImages.list());

    this.selectorSv.showList(imageList, []).subscribe((item) => {
      if (item) {
        this.castedQuestion().model.pattern.push(item);
      }
    });
  }

  removePossiblePattern(index: number) {
    if (index < this.castedQuestion().model.possiblePatternImages.length) {
      this.castedQuestion().model.pattern.splice(index, 1);
    }
  }

  showPossiblePatternSelector() {

    const imageList = Enums.ShapeImages.list().concat(Enums.QuestionImages.list());

    this.selectorSv.showList(imageList, []).subscribe((item) => {
      if (item) {
        this.castedQuestion().model.possiblePatternImages.push(item);
      }
    });

  }

}
